import React from 'react'
import "./AboutUs.css"
import { useNavigate } from 'react-router-dom'

export default function AboutScreen() {
    const navigate = useNavigate()
    return (
        <div className="about-page">
            {/* Hero Banner */}
            <section className="hero-banner position-relative">
                <div className="container-fluid p-0">
                    <div className="hero-image" style={{ backgroundImage: "url('/assets/about/upvc-hero.jpeg')" }}>
                        <div className="hero-overlay d-flex align-items-center">
                            <div className="container text-white">
                                <h1 className="display-4 fw_bold">Crafting Durability, Defining Spaces</h1>
                                <p className="lead">Your Trusted Partner in Premium UPVC Solutions</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Our Story */}
            <section className="py-5">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <h2 className="mb-4 fw_bold">Our Story</h2>
                            <p className="lead">
                                ZERCO began in 2005 with a mission to revolutionize the PVC industry. Today, we combine decades of expertise
                                with cutting-edge technology to deliver profiles that stand the test of time.
                            </p>
                            <p>
                                From humble beginnings to serving 15 countries, our journey reflects our commitment to excellence in UPVC profile manufacturing.
                            </p>
                        </div>
                        <div className="col-lg-6">
                            <img
                                src="/assets/about/factory-team.jpeg"
                                alt="ZERCO Factory Team"
                                className="img-fluid rounded shadow"
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* Why Choose Us */}
            <section className="py-5 bg-light">
                <div className="container">
                    <h2 className="text-center mb-5 fw_bold">Why Choose ZERCO?</h2>
                    <div className="row g-4">
                        <div className="col-md-4">
                            <div className="card h-100 border-0 shadow-sm">
                                {/* <img
                                    src="/images/weatherproof.jpg"
                                    className="card-img-top"
                                    alt="Weatherproof UPVC"
                                /> */}
                                <div className="card-body text-center">
                                    <div className="feature-icon display-4 mb-3">🌧️</div>
                                    <h3 className="h5">Weatherproof</h3>
                                    <p className="card-text">Resists extreme heat, cold, and moisture for decades</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card h-100 border-0 shadow-sm">
                                {/* <img
                                    src="/images/eco-friendly.jpg"
                                    className="card-img-top"
                                    alt="Eco Friendly UPVC"
                                /> */}
                                <div className="card-body text-center">
                                    <div className="feature-icon display-4 mb-3">♻️</div>
                                    <h3 className="h5">Eco-Friendly</h3>
                                    <p className="card-text">100% recyclable materials with low carbon footprint</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card h-100 border-0 shadow-sm">
                                {/* <img
                                    src="/images/custom-solutions.jpg"
                                    className="card-img-top"
                                    alt="Custom UPVC Profiles"
                                /> */}
                                <div className="card-body text-center">
                                    <div className="feature-icon display-4 mb-3">✂️</div>
                                    <h3 className="h5">Tailored Solutions</h3>
                                    <p className="card-text">Bespoke designs to match your unique vision</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Manufacturing Excellence */}
            {/* <section className="py-5">
                <div className="container">
                    <h2 className="text-center mb-5 fw_bold">Precision in Every Profile</h2>
                    <div className="row g-4 mb-4">
                        <div className="col-md-4">
                            <img
                                src="/assets/about/factory-floor.jpg"
                                alt="Factory Floor"
                                className="img-fluid rounded shadow"
                            />
                        </div>
                        <div className="col-md-4">
                            <img
                                src="/images/quality-check.jpg"
                                alt="Quality Check"
                                className="img-fluid rounded shadow"
                            />
                        </div>
                        <div className="col-md-4">
                            <img
                                src="/images/finished-products.jpg"
                                alt="Finished Products"
                                className="img-fluid rounded shadow"
                            />
                        </div>
                    </div>
                    <p className="text-center lead">
                        Our state-of-the-art facility ensures every profile meets international standards (ISO/CE certified).
                        Rigorous testing guarantees unmatched durability.
                    </p>
                </div>
            </section> */}

            {/* Team Spotlight */}
            <section className="py-5 bg-light">
                <div className="container">
                    <h2 className="text-center mb-5 fw_bold">Our Expert Team</h2>
                    <div className="row g-4 justify-content-center">
                        <div className="col-md-4 col-lg-3">
                            <div className="card border-0 text-center bg-transparent">
                                <img
                                    src="/assets/about/Dp1.png"
                                    className="rounded-circle mx-auto mb-3 shadow"
                                    width="150"
                                    height="150"
                                    alt="ZERCO Engineer"
                                />
                                <h3 className="h5">Alex Johnson</h3>
                                <p className="text-muted">Lead Product Designer</p>
                            </div>
                        </div>
                        <div className="col-md-4 col-lg-3">
                            <div className="card border-0 text-center bg-transparent">
                                <img
                                    src="/assets/about/Dp2.png"
                                    className="rounded-circle mx-auto mb-3 shadow"
                                    width="150"
                                    height="150"
                                    alt="ZERCO Technician"
                                />
                                <h3 className="h5">Maria Garcia</h3>
                                <p className="text-muted">Quality Control Specialist</p>
                            </div>
                        </div>
                        <div className="col-md-4 col-lg-3">
                            <div className="card border-0 text-center bg-transparent">
                                <img
                                    src="/assets/about/Dp3.png"
                                    className="rounded-circle mx-auto mb-3 shadow"
                                    width="150"
                                    height="150"
                                    alt="ZERCO Operations"
                                />
                                <h3 className="h5">David Kim</h3>
                                <p className="text-muted">Operations Manager</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Certifications */}
            <section className="py-5">
                <div className="container">
                    <h2 className="text-center mb-5 fw_bold">Certifications & Partners</h2>
                    <div className="row g-4 justify-content-center align-items-center">
                        <div className="col-6 col-md-3 text-center">
                            <img src="/assets/about/iso.png" alt="ISO Certified" className="img-fluid" style={{ maxHeight: '120px' }} />
                        </div>
                        <div className="col-6 col-md-3 text-center">
                            <img src="/assets/about/ce.png" alt="CE Certified" className="img-fluid" style={{ maxHeight: '60px' }} />
                        </div>
                        <div className="col-6 col-md-3 text-center">
                            <img src="/assets/about/indiamart.png" alt="Partner 1" className="img-fluid" style={{ maxHeight: '160px' }} />
                        </div>
                        <div className="col-6 col-md-3 text-center">
                            <img src="/Logo.png" alt="Partner 2" className="img-fluid" style={{ maxHeight: '80px' }} />
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section className="py-5 bg_main text-white">
                <div className="container text-center">
                    <h2 className="mb-4">Ready to transform your space?</h2>
                    <p className="lead mb-4">Let's collaborate on your next project with premium UPVC profiles</p>
                    <div className="d-flex justify-content-center gap-3">
                        <button className="btn btn-light btn-lg px-4">Get a Quote</button>
                        <button className="btn btn-outline-light btn-lg px-4" onClick={() => navigate("/product/all/main")}>Explore Products</button>
                    </div>
                </div>
            </section>
        </div>
    )
}
